import { render } from "./ShoppingCartStepThreeCardColumn.vue?vue&type=template&id=493f4492&scoped=true"
import script from "./ShoppingCartStepThreeCardColumn.vue?vue&type=script&lang=js"
export * from "./ShoppingCartStepThreeCardColumn.vue?vue&type=script&lang=js"

import "./ShoppingCartStepThreeCardColumn.vue?vue&type=style&index=0&id=493f4492&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-493f4492"

export default script